import * as React from 'react';
import targetSrc from './assets/target.png';
import forbiddenSrc from './assets/forbidden.png';
import pointerSrc from './assets/pointer.png';
import photoSrc from './assets/photo.png';
import fairPlaySrc from './assets/fairPlay.png';
import clockSrc from './assets/clock.png';
import topSrc from './assets/top.png';

export const targetIcon = <img width={32} height={32} src={targetSrc} />;
export const forbiddenIcon = <img width={28} height={28} src={forbiddenSrc} />;
export const pointerIcon = <img width={32} height={32} src={pointerSrc} />;
export const photoIcon = <img width={28} height={28} src={photoSrc} />;
export const fairPlayIcon = <img width={26} height={26} src={fairPlaySrc} />;
export const clockIcon = <img width={26} height={26} src={clockSrc} />;
export const topIcon = <img width={26} height={26} src={topSrc} />;
